"use strict";

var cov_2dk30ztqcj = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\ParallelScripture.js";
  var hash = "679556f5f485cbaedc3eb1cfb461ad9d997e70c6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\ParallelScripture.js",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 28
        },
        end: {
          line: 21,
          column: 38
        }
      },
      "1": {
        start: {
          line: 22,
          column: 30
        },
        end: {
          line: 22,
          column: 40
        }
      },
      "2": {
        start: {
          line: 23,
          column: 26
        },
        end: {
          line: 23,
          column: 41
        }
      },
      "3": {
        start: {
          line: 25,
          column: 20
        },
        end: {
          line: 25,
          column: 54
        }
      },
      "4": {
        start: {
          line: 26,
          column: 31
        },
        end: {
          line: 26,
          column: 36
        }
      },
      "5": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 78,
          column: 18
        }
      },
      "6": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 76,
          column: 6
        }
      },
      "7": {
        start: {
          line: 30,
          column: 19
        },
        end: {
          line: 30,
          column: 52
        }
      },
      "8": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 74,
          column: 7
        }
      },
      "9": {
        start: {
          line: 39,
          column: 12
        },
        end: {
          line: 39,
          column: 20
        }
      },
      "10": {
        start: {
          line: 40,
          column: 26
        },
        end: {
          line: 40,
          column: 31
        }
      },
      "11": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 44,
          column: 9
        }
      },
      "12": {
        start: {
          line: 43,
          column: 10
        },
        end: {
          line: 43,
          column: 33
        }
      },
      "13": {
        start: {
          line: 47,
          column: 10
        },
        end: {
          line: 58,
          column: 22
        }
      },
      "14": {
        start: {
          line: 59,
          column: 26
        },
        end: {
          line: 59,
          column: 67
        }
      },
      "15": {
        start: {
          line: 61,
          column: 10
        },
        end: {
          line: 65,
          column: 12
        }
      },
      "16": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 73,
          column: 10
        }
      },
      "17": {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 20
        }
      },
      "18": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 23
        }
      },
      "19": {
        start: {
          line: 80,
          column: 25
        },
        end: {
          line: 80,
          column: 75
        }
      },
      "20": {
        start: {
          line: 81,
          column: 30
        },
        end: {
          line: 81,
          column: 51
        }
      },
      "21": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 98,
          column: 39
        }
      },
      "22": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "23": {
        start: {
          line: 85,
          column: 16
        },
        end: {
          line: 85,
          column: 18
        }
      },
      "24": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 93,
          column: 7
        }
      },
      "25": {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 92,
          column: 9
        }
      },
      "26": {
        start: {
          line: 89,
          column: 10
        },
        end: {
          line: 89,
          column: 58
        }
      },
      "27": {
        start: {
          line: 90,
          column: 15
        },
        end: {
          line: 92,
          column: 9
        }
      },
      "28": {
        start: {
          line: 91,
          column: 10
        },
        end: {
          line: 91,
          column: 34
        }
      },
      "29": {
        start: {
          line: 95,
          column: 22
        },
        end: {
          line: 95,
          column: 53
        }
      },
      "30": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 24
        }
      },
      "31": {
        start: {
          line: 100,
          column: 2
        },
        end: {
          line: 116,
          column: 4
        }
      },
      "32": {
        start: {
          line: 119,
          column: 0
        },
        end: {
          line: 134,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "ParallelScripture",
        decl: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 26
          }
        },
        loc: {
          start: {
            line: 20,
            column: 3
          },
          end: {
            line: 117,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 13
          }
        },
        loc: {
          start: {
            line: 28,
            column: 18
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 29,
            column: 34
          },
          end: {
            line: 29,
            column: 35
          }
        },
        loc: {
          start: {
            line: 29,
            column: 48
          },
          end: {
            line: 76,
            column: 5
          }
        },
        line: 29
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 83,
            column: 13
          }
        },
        loc: {
          start: {
            line: 83,
            column: 18
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 83
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 19,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 19,
            column: 16
          },
          end: {
            line: 19,
            column: 20
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }, {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        }, {
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        }],
        line: 42
      },
      "3": {
        loc: {
          start: {
            line: 80,
            column: 25
          },
          end: {
            line: 80,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 25
          },
          end: {
            line: 80,
            column: 34
          }
        }, {
          start: {
            line: 80,
            column: 38
          },
          end: {
            line: 80,
            column: 50
          }
        }, {
          start: {
            line: 80,
            column: 54
          },
          end: {
            line: 80,
            column: 75
          }
        }],
        line: 80
      },
      "4": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        }],
        line: 84
      },
      "5": {
        loc: {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        }, {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        }],
        line: 87
      },
      "6": {
        loc: {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 92,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 92,
            column: 9
          }
        }, {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 92,
            column: 9
          }
        }],
        line: 88
      },
      "7": {
        loc: {
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 88,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 88,
            column: 29
          }
        }, {
          start: {
            line: 88,
            column: 33
          },
          end: {
            line: 88,
            column: 48
          }
        }],
        line: 88
      },
      "8": {
        loc: {
          start: {
            line: 90,
            column: 15
          },
          end: {
            line: 92,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 15
          },
          end: {
            line: 92,
            column: 9
          }
        }, {
          start: {
            line: 90,
            column: 15
          },
          end: {
            line: 92,
            column: 9
          }
        }],
        line: 90
      },
      "9": {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 115,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 101,
            column: 5
          },
          end: {
            line: 101,
            column: 10
          }
        }, {
          start: {
            line: 101,
            column: 14
          },
          end: {
            line: 101,
            column: 20
          }
        }, {
          start: {
            line: 101,
            column: 24
          },
          end: {
            line: 101,
            column: 29
          }
        }, {
          start: {
            line: 102,
            column: 6
          },
          end: {
            line: 114,
            column: 8
          }
        }, {
          start: {
            line: 115,
            column: 10
          },
          end: {
            line: 115,
            column: 15
          }
        }],
        line: 101
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "679556f5f485cbaedc3eb1cfb461ad9d997e70c6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useDeepCompareEffect = _interopRequireDefault(require("use-deep-compare-effect"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepFreeze = _interopRequireDefault(require("deep-freeze"));

var _Resources = require("../resources/Resources.context");

var _ = require("../../");

var _license = require("../license");

var _localStrings = require("../../core/localStrings");

function ParallelScripture(_ref) {
  var _resources$;

  var reference = _ref.reference,
      quote = _ref.quote,
      onQuote = _ref.onQuote,
      occurrence = _ref.occurrence,
      height = _ref.height,
      buttons = _ref.buttons,
      _ref$open = _ref.open,
      _open = _ref$open === void 0 ? (cov_2dk30ztqcj.b[0][0]++, true) : _ref$open;

  cov_2dk30ztqcj.f[0]++;

  var _ref2 = (cov_2dk30ztqcj.s[0]++, (0, _react.useState)()),
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      title = _ref3[0],
      setTitle = _ref3[1];

  var _ref4 = (cov_2dk30ztqcj.s[1]++, (0, _react.useState)()),
      _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
      titles = _ref5[0],
      setTitles = _ref5[1];

  var _ref6 = (cov_2dk30ztqcj.s[2]++, (0, _react.useState)(_open)),
      _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
      open = _ref7[0],
      setOpen = _ref7[1];

  var _ref8 = (cov_2dk30ztqcj.s[3]++, _react.default.useContext(_Resources.ResourcesContext)),
      state = _ref8.state;

  var _ref9 = (cov_2dk30ztqcj.s[4]++, state),
      resources = _ref9.resources,
      books = _ref9.books;

  cov_2dk30ztqcj.s[5]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_2dk30ztqcj.f[1]++;

    var _titles = (cov_2dk30ztqcj.s[6]++, resources.map(function (resource) {
      cov_2dk30ztqcj.f[2]++;

      var _title = (cov_2dk30ztqcj.s[7]++, "Error: ".concat(resource.resourceLink));

      cov_2dk30ztqcj.s[8]++;

      if (resource.manifest) {
        cov_2dk30ztqcj.b[1][0]++;

        var _ref10 = (cov_2dk30ztqcj.s[9]++, resource),
            _ref10$manifest$dubli = _ref10.manifest.dublin_core,
            _title2 = _ref10$manifest$dubli.title,
            version = _ref10$manifest$dubli.version,
            rights = _ref10$manifest$dubli.rights;

        var branchOrTag = (cov_2dk30ztqcj.s[10]++, 'tag');
        cov_2dk30ztqcj.s[11]++;

        if (resource.tag === 'master') {
          cov_2dk30ztqcj.b[2][0]++;
          cov_2dk30ztqcj.s[12]++;
          branchOrTag = 'branch';
        } else {
          cov_2dk30ztqcj.b[2][1]++;
        }

        var licenseLink = (cov_2dk30ztqcj.s[13]++, resource.config.server + '/' + resource.username + '/' + resource.repository + '/' + 'src/' + branchOrTag + '/' + resource.tag + '/' + 'LICENSE.md');
        var viewLicense = (cov_2dk30ztqcj.s[14]++, (0, _localStrings.localString)('ViewLicense') + ' ' + rights);
        var rightsIcon = (cov_2dk30ztqcj.s[15]++, _react.default.createElement(_license.License, {
          rights: viewLicense,
          licenseLink: licenseLink,
          style: {
            fontSize: '1em',
            marginLeft: '0.1em'
          }
        }));
        cov_2dk30ztqcj.s[16]++;
        _title = _react.default.createElement(_core.Typography, {
          variant: "caption"
        }, _title2, " v", version, rightsIcon);
      } else {
        cov_2dk30ztqcj.b[1][1]++;
      }

      cov_2dk30ztqcj.s[17]++;
      return _title;
    }));

    cov_2dk30ztqcj.s[18]++;
    setTitles(_titles);
  }, [resources]);
  var currentProject = (cov_2dk30ztqcj.s[19]++, (cov_2dk30ztqcj.b[3][0]++, resources) && (cov_2dk30ztqcj.b[3][1]++, resources[0]) && (cov_2dk30ztqcj.b[3][2]++, (_resources$ = resources[0]) === null || _resources$ === void 0 ? void 0 : _resources$.project));
  var currentProjectTitle = (cov_2dk30ztqcj.s[20]++, currentProject === null || currentProject === void 0 ? void 0 : currentProject.title);
  cov_2dk30ztqcj.s[21]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_2dk30ztqcj.f[3]++;
    cov_2dk30ztqcj.s[22]++;

    if (currentProjectTitle) {
      cov_2dk30ztqcj.b[4][0]++;
      var ref = (cov_2dk30ztqcj.s[23]++, '');
      cov_2dk30ztqcj.s[24]++;

      if (reference) {
        cov_2dk30ztqcj.b[5][0]++;
        cov_2dk30ztqcj.s[25]++;

        if ((cov_2dk30ztqcj.b[7][0]++, reference.chapter) && (cov_2dk30ztqcj.b[7][1]++, reference.verse)) {
          cov_2dk30ztqcj.b[6][0]++;
          cov_2dk30ztqcj.s[26]++;
          ref = reference.chapter + ':' + reference.verse;
        } else {
          cov_2dk30ztqcj.b[6][1]++;
          cov_2dk30ztqcj.s[27]++;

          if (reference.chapter) {
            cov_2dk30ztqcj.b[8][0]++;
            cov_2dk30ztqcj.s[28]++;
            ref = reference.chapter;
          } else {
            cov_2dk30ztqcj.b[8][1]++;
          }
        }
      } else {
        cov_2dk30ztqcj.b[5][1]++;
      }

      var __title = (cov_2dk30ztqcj.s[29]++, currentProjectTitle + ' ' + ref);

      cov_2dk30ztqcj.s[30]++;
      setTitle(__title);
    } else {
      cov_2dk30ztqcj.b[4][1]++;
    }
  }, [reference, currentProjectTitle]);
  cov_2dk30ztqcj.s[31]++;
  return (cov_2dk30ztqcj.b[9][0]++, title) && (cov_2dk30ztqcj.b[9][1]++, titles) && (cov_2dk30ztqcj.b[9][2]++, books) && (cov_2dk30ztqcj.b[9][3]++, _react.default.createElement(_.ScriptureTable, {
    titles: titles,
    books: books,
    title: title,
    reference: reference,
    height: height,
    quote: quote // onQuote={onQuote} // disable until round trip is working
    ,
    occurrence: occurrence,
    buttons: buttons,
    open: open,
    onOpen: setOpen
  })) || (cov_2dk30ztqcj.b[9][4]++, _react.default.createElement(_react.default.Fragment, null));
}

cov_2dk30ztqcj.s[32]++;
ParallelScripture.propTypes = {
  /** the reference to scroll into view */
  reference: _propTypes.default.shape({
    bookId: _propTypes.default.string,
    chapter: _propTypes.default.number,
    verse: _propTypes.default.number
  }),

  /** pass the quote in */
  quote: _propTypes.default.string.isRequired,

  /** callback to return the quote when selections made */
  onQuote: _propTypes.default.func,

  /** set the height to ensure rendering work properly   */
  height: _propTypes.default.string.isRequired,

  /** set the default open state */
  open: _propTypes.default.string
};
var _default = ParallelScripture;
exports.default = _default;